import { Component, OnInit } from '@angular/core';
import { PolicyClient } from '../../../app/api/benefits-clients';
import { BehaviorSubject } from 'rxjs';
import { UserContext } from '../../services/user-context/user-context.types';
import { UserContextService } from '../../services/user-context/user-context.service';
import { Constants } from '@benefitsui/app/pages/billing-page/billing-page.types';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataLabel } from '@benefitsui/app/shared/interfaces/IDataLabel';

@Component({
  selector: 'app-policy-overview-page',
  templateUrl: './policy-overview-page.component.html',
  styleUrls: ['./policy-overview-page.component.scss'],
  providers: [UserContextService]
})
export class PolicyOverviewPageComponent implements OnInit {
  constructor(
    private userContextService: UserContextService,
    private policyClient: PolicyClient,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.userContext = this.userContextService.get();
    this.userFirstName = this.userContext.currentUserFirstName;
  }

  token = '';
  userContext: UserContext;
  userFirstName: string;
  toolTip: TooltipContent = {
    heading: 'Tooltip!',
    body: 'You found me!'
  };

  overviewData!: OverviewData;
  managerData!: ManagerData;
  paymentsData!: PaymentsData;

  formatDate(date: string | undefined): string {
    if (!date) {
      return '';
    }
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString();
  }

  formatCurrency(amount: number | undefined): string {
    if (!amount) {
      return '';
    }
    return amount.toLocaleString('en-US', { style: 'currency', currency: Constants.CurrencyUsdKey });
  }
  $hasPolicyData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  ngOnInit(): void {
    this.policyClient.overview().subscribe(
      (response) => {
        const { data } = response;
        if (response.data?.policyDetails === null) {
          this.$hasPolicyData.next(false);
          return;
        }
        this.overviewData = {
          ...this.overviewData,
          policyToken: data?.policyToken ?? '',
          policyNumber: { data: data?.policyDetails?.policyId ?? '', label: 'Policy number' },
          policyHolder: { data: data?.policyDetails?.policyHolder ?? '', label: 'Policyholder' },
          status: { data: data?.policyDetails?.status ?? '', label: 'Status' },
          effectiveDate: { data: this.formatDate(data?.policyDetails?.effectiveDate), label: 'Effective date' },
          nextRenewalDate: { data: this.formatDate(data?.policyDetails?.nextRenewalDate), label: 'Next renewal date' }
        };

        this.managerData = {
          ...this.managerData,
          managerName: { data: data?.contactInfo?.[0]?.accountManagerName ?? '', label: 'Name' },
          managerEmail: { data: data?.contactInfo?.[0]?.accountManagerEmail ?? '', label: 'Email' },
          managerPhoneNumber: { data: data?.contactInfo?.[0]?.accountManagerPhone ?? '', label: 'Phone number' }
        };

        this.paymentsData = {
          ...this.paymentsData,
          estimatedPayment: {
            data: this.formatCurrency(data?.payments?.estimatedPaymentAmountDue),
            label: 'Estimated payment'
          },
          lastPayment: { data: this.formatCurrency(data?.payments?.lastPaymentAmount), label: 'Last payment' },
          billingMethod: { data: data?.payments?.billingMethod ?? '', label: 'Billing method' },
          due: { data: this.formatDate(data?.payments?.dueDate), label: 'Due' },
          paid: { data: this.formatDate(data?.payments?.lastPaymentDate), label: 'Paid' }
        };
      },
      () => {},
      () => {
        this.token = this.overviewData.policyToken ?? '';
        const queryParams: Params = { token: this.token };
        if (this.router) {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams,
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
      }
    );
  }
}

export interface TooltipContent {
  body: string;
  heading: string;
}
export interface OverviewData {
  policyToken: string;
  policyNumber: DataLabel;
  policyHolder: DataLabel;
  status: DataLabel;
  effectiveDate: DataLabel;
  nextRenewalDate: DataLabel;
}

export interface ManagerData {
  managerName: DataLabel;
  managerEmail: DataLabel;
  managerPhoneNumber: DataLabel;
}

export interface PaymentsData {
  estimatedPayment: DataLabel;
  lastPayment: DataLabel;
  billingMethod: DataLabel;
  due: DataLabel;
  paid: DataLabel;
}
